<script>
import Username from '@wielink-application/shared/vue/components/form/input-only/username.vue'

export default Username;
</script>